import { useState, useCallback } from 'react';
import environment from '../../../environments/environment';
import { axiosInterceptor } from '../services/authInterceptor';
import * as constants  from "../../../constants"

export const useLoanNumber = () => {
  const [loanNumber, setLoanNumber] = useState<any[]>([]);
  const GET_LOAN_ID = environment.postNewLoan;
  
  const getLoanNumber = useCallback(async (participantId:any,clientId:any) => {
    try {
      const response = await axiosInterceptor.get(
        `${GET_LOAN_ID}participant/${participantId}?clientId=${clientId}`
      );
      if (response && response.status === constants.STATUS_CODES.SUCCESS) {
        const loanData = response?.data?.data;
         setLoanNumber(loanData);
      }
    } catch (error: any) {
        console.warn(error)
    }
  }, []);

  return { loanNumber, getLoanNumber ,setLoanNumber};
};
